import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';

import { b } from 'utils/i18nUtils';

import { getSelectedSelfServiceId } from 'modules/auth/selectors';

import restrictedAccessApi from 'modules/restrictedAccess/service';

import { Button } from 'components/ui';
import { ButtonType } from 'components/ui/Button';

type RelayProps = {
  onCancel?: (event: React.MouseEvent<HTMLButtonElement>) => void
  onContinue?: (event: React.MouseEvent<HTMLButtonElement>) => void
};

const Relay: React.FC<RelayProps> = ({ onContinue, onCancel }) => {
  const selfServiceId = useSelector(getSelectedSelfServiceId);
  const { isLoading } = useSelector(restrictedAccessApi.endpoints.open.select(selfServiceId));

  return (
    <>
      <div className="text-center [&>p]:inline [&>p]:mx-1">
        <FormattedMessage
          id="restrictedAccess.modal.description"
          tagName="p"
          defaultMessage="Outside the dealership's opening hours, access to the kiosk may be restricted by a gate."
        />
        <FormattedMessage
          id="restrictedAccess.modal.relayDescription"
          tagName="p"
          values={{ b }}
          defaultMessage="In this case, <b>click the button below</b> to open it."
        />
      </div>
      <div className="flex flex-col gap-xs">
        <Button type={ButtonType.TERTIARY} onClick={onContinue} loading={isLoading} testId="open-btn">
          <FormattedMessage id="restrictedAccess.modal.open" defaultMessage="Open the gate" />
        </Button>
        <Button type={ButtonType.SECONDARY} onClick={onCancel} disabled={isLoading} testId="continue-btn">
          <FormattedMessage id="header.cancel" defaultMessage="No, continue" />
        </Button>
      </div>
    </>
  );
};

export default Relay;
